var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico__x2F__napoveda"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.7,21.9c0,0.55,0.439,1.1,1.1,1.1h4.4c0.659,0,1.1-0.55,1.1-1.1V20.8H8.7V21.9z M12,1 C7.71,1,4.3,4.41,4.3,8.7c0,2.64,1.32,4.95,3.3,6.271V17.5c0,0.55,0.44,1.1,1.1,1.1h6.6c0.66,0,1.101-0.55,1.101-1.1v-2.529 c1.979-1.431,3.3-3.741,3.3-6.271C19.7,4.41,16.29,1,12,1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.7820df37a9a1bc51a6b583bb85a7e48e.svg";
export { ForwardRef as ReactComponent };